export const type0Breakpoints = {
    400: {
        slidesPerView: 1.33,
    },
    475: {
        slidesPerView: 1.5,
    },
    576: {
        centeredSlides: false,
        slidesPerView: 2.15,
    },
    768: {
        centeredSlides: false,
        slidesPerView: 2.36,
        spaceBetween: 18,
    },
    1050: {
        centeredSlides: false,
        slidesPerView: 3.16,
        spaceBetween: 18,
    },
    1200: {
        centeredSlides: false,
        slidesPerView: 3.3,
        spaceBetween: 18,
    },
    1350: {
        centeredSlides: false,
        slidesPerView: 3.5,
        spaceBetween: 18,
    },
    1440: {
        centeredSlides: false,
        slidesPerView: 4.16,
        spaceBetween: 25,
    },
    1700: {
        centeredSlides: false,
        slidesPerView: 4.16,
        spaceBetween: 35,
    },
};
